import { render, staticRenderFns } from "./PricingPlanModal.vue?vue&type=template&id=0149d248&"
import script from "./PricingPlanModal.vue?vue&type=script&lang=js&"
export * from "./PricingPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports